import React from 'react';
import {Field} from 'redux-form';

import {SelectField} from 'components/Fields';
import FormField from 'components/FormField';
import Label from 'components/Label';

import {headOption} from 'utils/common';
import {selectBookingSetsByTenant} from 'ducks/bookingSets';

export const buildBookingSetOption = bookingSet => ({
  value: bookingSet.id,
  label:
    `Booking Set No:${bookingSet.id} with status "${bookingSet.status}"` +
    (bookingSet.rooms ? ` in rooms ${bookingSet.rooms}` : '')
});

export const initialValues = state => {
  const bookingSets = selectBookingSetsByTenant(state);

  return {
    bookingSet: headOption(bookingSets, buildBookingSetOption)
  };
};

const BookingSetSection = ({bookingSets}) => (
  <FormField>
    <Label>Booking Set</Label>
    <Field
      name="bookingSet"
      component={SelectField}
      options={[
        {label: 'Create New'},
        ...bookingSets.map(buildBookingSetOption)
      ]}
      placeholder="Create New"
    />
  </FormField>
);

export default BookingSetSection;
